(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
function initDormellaProducts(scope=document){
  scope.querySelectorAll('.dp').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const config=JSON.parse(root.querySelector('[data-product-config]').textContent);
    const slides=[...root.querySelectorAll('[data-media]')];
    const thumbs=[...root.querySelectorAll('[data-thumbnail]')];
    const show=index=>{
      if(!slides.length)return;
      index=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.hidden=i!==index;if(i!==index){slide.querySelectorAll('video').forEach(video=>video.pause());slide.querySelectorAll('iframe').forEach(frame=>{if(!slide.hidden)return;const src=frame.getAttribute('src');frame.setAttribute('src',src);});}});
      thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));
      const counter=root.querySelector('[data-counter]');if(counter)counter.textContent=`${index+1} / ${slides.length}`;
    };
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    const current=()=>slides.findIndex(slide=>!slide.hidden);
    root.querySelector('[data-prev]')?.addEventListener('click',()=>show(current()-1));
    root.querySelector('[data-next]')?.addEventListener('click',()=>show(current()+1));
    if(slides.length)show(Math.max(0,current()));
    const form=root.querySelector('form');
    const quantity=form.querySelector('[name=quantity]');
    root.querySelector('[data-minus]').addEventListener('click',()=>{quantity.stepDown();quantity.dispatchEvent(new Event('change',{bubbles:true}));});
    root.querySelector('[data-plus]').addEventListener('click',()=>{quantity.stepUp();quantity.dispatchEvent(new Event('change',{bubbles:true}));});
    const plan=form.querySelector('[name=selling_plan]');
    const activeVariant=()=>config.variants.find(v=>String(v.id)===String(new FormData(form).get('id')));
    const price=variant=>{const allocation=variant.plans.find(p=>String(p.id)===plan?.value);root.querySelector('[data-price]').textContent=allocation?.price||variant.price;root.querySelector('[data-compare]').textContent=variant.compare;root.querySelector('[data-compare]').hidden=!!allocation||!variant.sale;root.querySelector('[data-sale]').hidden=!!allocation||!variant.sale;};
    const update=(navigate=false)=>{
      const variant=activeVariant();if(!variant)return;
      if(plan){const old=plan.value;plan.replaceChildren();if(!config.requiresPlan)plan.add(new Option(config.labels.oneTime,''));variant.plans.forEach(p=>plan.add(new Option(p.name,String(p.id))));if([...plan.options].some(option=>option.value===old))plan.value=old;}
      price(variant);
      const available=variant.available&&(!config.requiresPlan||variant.plans.length>0);
      root.querySelector('[data-add]').disabled=!available;
      root.querySelector('[data-add-label]').textContent=available?config.labels.add:config.labels.sold;
      root.querySelector('[data-stock]').textContent=available?config.labels.available:config.labels.sold;
      const express=root.querySelector('.dp-express');if(express)express.hidden=!available;
      quantity.min=variant.min||1;quantity.step=variant.step||1;if(variant.max)quantity.max=variant.max;else quantity.removeAttribute('max');quantity.value=variant.min||1;
      if(navigate){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);const index=slides.findIndex(slide=>slide.dataset.media===String(variant.media));if(index>=0)show(index);}
    };
    form.querySelectorAll('[name=id]').forEach(input=>input.addEventListener('change',()=>update(true)));
    plan?.addEventListener('change',()=>price(activeVariant()));
    update();
  });
}
initDormellaProducts();
document.addEventListener('shopify:section:load',event=>initDormellaProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    document.querySelectorAll('product-recommendations[data-url]').forEach(element=>{if(element.dataset.loaded)return;element.dataset.loaded='true';fetch(element.dataset.url).then(response=>response.text()).then(text=>{const html=new DOMParser().parseFromString(text,'text/html').querySelector('product-recommendations');if(html?.innerHTML.trim())element.innerHTML=html.innerHTML;}).catch(()=>{});});
  } catch(e) { console.error(e); }
})();
})();
